import React, { Fragment, useContext, useEffect, useState } from "react";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import { Container, DateLayer } from "../Layout";
import { SubMenu } from "./ProofApply";

import _logo_insur_01 from "../../resources/images/sub/logo_insur_01.png";
import _logo_insur_02 from "../../resources/images/sub/logo_insur_02.png";
import _logo_insur_03 from "../../resources/images/sub/logo_insur_03.png";
import _logo_insur_04 from "../../resources/images/sub/logo_insur_04.png";
import _logo_insur_05 from "../../resources/images/sub/logo_insur_05.png";
import _logo_insur_06 from "../../resources/images/sub/logo_insur_06.png";
import _logo_insur_07 from "../../resources/images/sub/logo_insur_07.png";
import _logo_insur_08 from "../../resources/images/sub/logo_insur_08.png";
import _logo_insur_09 from "../../resources/images/sub/logo_insur_09.png";
import _logo_insur_10 from "../../resources/images/sub/logo_insur_10.png";
import _logo_insur_11 from "../../resources/images/sub/logo_insur_11.png";
import _logo_insur_12 from "../../resources/images/sub/logo_insur_12.png";
import _logo_insur_13 from "../../resources/images/sub/logo_insur_13.png";
import _logo_insur_14 from "../../resources/images/sub/logo_insur_14.png";
import _logo_insur_15 from "../../resources/images/sub/logo_insur_15.png";
import _logo_insur_16 from "../../resources/images/sub/logo_insur_16.png";
import _logo_insur_17 from "../../resources/images/sub/logo_insur_17.png";
import _logo_insur_18 from "../../resources/images/sub/logo_insur_18.png";
import _logo_insur_19 from "../../resources/images/sub/logo_insur_19.png";
import _logo_insur_20 from "../../resources/images/sub/logo_insur_20.png";
import _logo_insur_21 from "../../resources/images/sub/logo_insur_21.png";
import _logo_insur_22 from "../../resources/images/sub/logo_insur_22.png";
import _logo_insur_23 from "../../resources/images/sub/logo_insur_23.png";
import _logo_insur_24 from "../../resources/images/sub/logo_insur_24.png";
import _logo_insur_25 from "../../resources/images/sub/logo_insur_25.png";
import _logo_insur_26 from "../../resources/images/sub/logo_insur_26.png";
import _logo_insur_27 from "../../resources/images/sub/logo_insur_27.png";
import _logo_insur_28 from "../../resources/images/sub/logo_insur_28.png";
import _logo_insur_29 from "../../resources/images/sub/logo_insur_29.png";
import _logo_insur_30 from "../../resources/images/sub/logo_insur_30.png";

export default () => {

    useEffect(()=> {
        $(".round-blue-tab a").click(function(){
            if(!$(this).hasClass("on")){
                var idx = $(this).index();
                $(".round-blue-tab a").removeClass("on");
                $(this).addClass("on");

                $(".insur-tab-container > div").hide();
                $(".insur-tab-container > div").eq(idx).show();
            }
        });
    }, []);

    return (
        <Fragment>
            <ScrollToTop />
            <Container Title="보험사 선택" proof="CLAIM">
                <div className="contents sub grad">
                    <SubMenu code="APPLY" />

                    <div className="sub-contents">
                        <div className="round-blue-tab pp w2">
                            <a className="on">손해보험사</a>
                            <a>생명보험사</a>
                        </div>

                        <div className="insur-tab-container">
                            <div className="thr-lgbox-list">
                                <ul>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_01} alt="" />
                                            <p>KB손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_02} alt="" />
                                            <p>삼성화재</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_03} alt="" />
                                            <p>NH농협손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_04} alt="" />
                                            <p>흥국화재</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_05} alt="" />
                                            <p>현대해상</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_06} alt="" />
                                            <p>DB손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_07} alt="" />
                                            <p>메리츠화재</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_08} alt="" />
                                            <p>한화손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_09} alt="" />
                                            <p>롯데손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_10} alt="" />
                                            <p>MG손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_11} alt="" />
                                            <p>AXA손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_12} alt="" />
                                            <p>AIG손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_13} alt="" />
                                            <p>하나손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_14} alt="" />
                                            <p>에이스손해보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_15} alt="" />
                                            <p>카디프손해보험</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="thr-lgbox-list">
                                <ul>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_03} alt="" />
                                            <p>NH농협생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_16} alt="" />
                                            <p>미래에셋생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_17} alt="" />
                                            <p>신한생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_18} alt="" />
                                            <p>메트라이프생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_04} alt="" />
                                            <p>흥국생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_02} alt="" />
                                            <p>삼성생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_19} alt="" />
                                            <p>교보생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_08} alt="" />
                                            <p>한화생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_20} alt="" />
                                            <p>ABL생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_21} alt="" />
                                            <p>DGB생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_22} alt="" />
                                            <p>KDB생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_23} alt="" />
                                            <p>동양생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_06} alt="" />
                                            <p>DB생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_24} alt="" />
                                            <p>푸르덴셜생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_25} alt="" />
                                            <p>처브라이프생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_26} alt="" />
                                            <p>오렌지라이프<br/>생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_13} alt="" />
                                            <p>하나생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_15} alt="" />
                                            <p>카디프생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_27} alt="" />
                                            <p>푸본현대생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_28} alt="" />
                                            <p>라이나생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_29} alt="" />
                                            <p>AIA생명</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_01} alt="" />
                                            <p>KB생명보험</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <img src={_logo_insur_30} alt="" />
                                            <p>교보라이프<br/>플래닛생명</p>
                                        </a>
                                    </li>

                                    
                                </ul>
                            </div>
                        </div>
                    </div>	
                </div>
            </Container>
        </Fragment>
    );
}